let getPublicationsByYear = async ({
  url,
  community_id,
  year = 2020,
  currentPage = 1,
  itemsPerPage = 20,
}) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      query: `{
        communityById(id: "${community_id}") {
          name
          description
          items(
            first: ${itemsPerPage}
            page: ${currentPage}
            hasMetadata: {
              AND: [
                { column: METADATA_FIELD_ID, operator: EQ, value: 15 }
                { column: VALUE, operator: LIKE, value: "${year}%" }
              ]
            }
          ) {
            paginatorInfo {
              count
              currentPage
              hasMorePages
              total
              perPage
            }
            data {
              id
              handle
              thumbnail
              url
              metadata{
                id
                metadata_field_id
                element
                qualifier
                value
              }
            }
          }
        }
      }`,
    }),
  })
    .then((response) => response.json())
    .then((response) => response.data.communityById);
};

let getPublicationsByCollection = async ({
  url,
  collection_id,
  currentPage = 1,
  itemsPerPage = 20,
}) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      query: `{
        collectionById(id: "${collection_id}") {
          name
          facetIssuedYear
          items(
            first: ${itemsPerPage}
            page: ${currentPage}
            orderBy: [
              { column: ISSUED_DATE, order: DESC },
              { column: HANDLE, order: DESC }
            ]
          ) {
            paginatorInfo {
              count
              currentPage
              hasMorePages
              total
              perPage
            }
            data {
              id
              handle
              thumbnail
              url
              metadata {
                id
                metadata_field_id
                element
                qualifier
                value
              }
            }
          }
        }
      }`,
    }),
  })
    .then((response) => response.json())
    .then((response) => response.data.collectionById);
};

export { getPublicationsByYear, getPublicationsByCollection };
